export default {
  customerCart: {
    withItems: true,
    withItemDetails: true,
    withItemPrices: true,
    withPaymentSummary: true,
    withItemConfigurableOptions: true,
    withStoreLocations: true
  },
  guestCart: {
    withItems: true,
    withItemDetails: true,
    withItemPrices: true,
    withPaymentSummary: true,
    withItemConfigurableOptions: true,
    withStoreLocations: true
  },
  addCartItem: {
    withItems: true,
    withItemDetails: true,
    withItemPrices: true,
    withPaymentSummary: true,
    withItemConfigurableOptions: true
  },
  updateCartItem: {
    withItems: true,
    withItemDetails: true,
    withItemPrices: true,
    withPaymentSummary: true,
    withItemConfigurableOptions: true
  },
  mergeCart: {
    withItems: true,
    withItemDetails: true,
    withItemPrices: true,
    withItemConfigurableOptions: true,
    withPaymentSummary: true
  },
  removeCartItem: {
    withItems: true,
    withItemDetails: true,
    withItemPrices: true,
    withPaymentSummary: true,
    withItemConfigurableOptions: true
  },
  applyCouponToCart: {
    withPaymentSummary: true,
    withAppliedCodes: true
  },
  removeCouponToCart: {
    withPaymentSummary: true,
    withAppliedCodes: true
  },
  setShippingMethod: {
    withShippingAddress: true,
    withPaymentSummary: true
  },
  applyRewardToCart: {
    withPaymentSummary: true,
    withAppliedRewardPoints: true
  },
  removeRewardFromCard: {
    withPaymentSummary: true,
    withAppliedRewardPoints: true
  },
  setCartAddress: {
    withShippingAddress: true,
    withPaymentSummary: true,
    withShippingMethods: true,
    withSelectedShippingMethod: true
  }
};
export const routeOptionsMapper = {
  cart: {
    customerCart: {
      withItems: true,
      withItemDetails: true,
      withItemPrices: true,
      withPaymentSummary: true,
      withStoreLocations: true
    },
    guestCart: {
      withItems: true,
      withItemDetails: true,
      withPaymentSummary: true,
      withStoreLocations: true
    },
    updateCartItem: {
      withItems: true,
      withItemDetails: true,
      withItemPrices: true,
      withPaymentSummary: true
    }
  },
  "checkout-shipping": {
    customerCart: {
      withItems: true,
      withItemDetails: true,
      withPaymentSummary: true,
      withAppliedCodes: true,
      withAppliedRewardPoints: true,
      withSelectedShippingMethod: true,
      withShippingAddress: true
    },
    guestCart: {
      withItems: true,
      withItemDetails: true,
      withItemPrices: true,
      withPaymentSummary: true,
      withAppliedCodes: true,
      withAppliedRewardPoints: true,
      withSelectedShippingMethod: true,
      withShippingAddress: true
    }
  },
  "checkout-pay": {
    customerCart: {
      withItems: true,
      withItemDetails: true,
      withPaymentSummary: true,
      withSelectedShippingMethod: true,
      withShippingMethods: true,
      withShippingAddress: true,
      withStoreLocations: true,
      withAppliedRewardPoints: true,
      withAppliedCodes: true
    },
    guestCart: {
      withItems: true,
      withItemDetails: true,
      withItemPrices: true,
      withPaymentSummary: true,
      withSelectedShippingMethod: true,
      withShippingMethods: true,
      withShippingAddress: true,
      withStoreLocations: true,
      withAppliedRewardPoints: true
    },
    setShippingMethod: {
      withShippingAddress: true,
      withSelectedShippingMethod: true,
      withShippingMethods: true
    },
    setPaymentMethod: {
      withPaymentMethods: true,
      withPaymentSummary: true
    }
  }
};
